import { Box, Stack } from "@mui/material";
import React, { useState } from "react";
import { Color, FontStyle, JobDisplays } from "../../constants";
import { getExperienceTag, JobFontSize, JobTag } from "../../utils/jobUtils";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavHeartContainer from "../FavHeartContainer";
import JobDetails from "./JobDetails";
import { jobIsFetti } from "../../utils/utils";
import JobDetailsMenu from "./JobDetailsMenu";

const styles = {
  container: {
    width: "100%",
    minWidth: "",
    height: "100%",
    paddingBottom: "24px",
    // zIndex: 1,
    // overflow: 'auto',
  },
  panel: {
    ...FontStyle.body,
    width: "100%",
    borderRadius: JobDisplays.borderRadius,
    backgroundColor: JobDisplays.backgroundColor,
    boxShadow: JobDisplays.boxShadow,
    padding: JobDisplays.padding,
    cursor: "pointer",
    transition: "boxShadow 0.3s ease-in-out",
    position: "relative",
  },
  panelBare: {
    ...FontStyle.body,
    width: "100%",
    borderRadius: JobDisplays.borderRadius,
    // backgroundColor: JobDisplays.backgroundColor,
    // boxShadow: JobDisplays.boxShadow,
    // padding: JobDisplays.padding,
    // cursor: "pointer",
    transition: "boxShadow 0.3s ease-in-out",
    position: "relative",
  },
  selectedPanel: {
    // boxShadow: "0px 0px 13px rgb(0 190 240 / 100%)",
    // boxShadow: "0px 0px 12px #150BD9",
    boxShadow:
      "0px 0px 10px #0AE9F080, 0px 0px 10px #0110FA80, 0px 0px 5px #0110FA80",
    // border: "2px solid #0AE9F0",
    // filter: "drop-shadow(0px 0px 12px #150BD9)",
    // filter: "drop-shadow(0px 0px 12px #0021DB)",
    // "0px 0px 33px rgb(0 190 240 / 100%), 0px 0px 33px rgb(0 190 240 / 100%)",
    // "0px 0px 12px rgb(0 190 240 / 100%)",

    // "0px 0px 12px #D1B9FA, 2px 2px 8px #D1B9FAa0, 2px 2px 8px #D1B9FAa0",
    // boxShadow: `0px 0px 13px ${Color.primary}`,
    // backgroundColor: Color.primaryLight,
  },
  compLogo: {
    backgroundColor: "#ddd",
    borderRadius: "10px",
    width: "50px",
    minWidth: "50px",
    height: "50px",
    display: "flex",

    fontSize: "30px",
    justifyContent: "center",
    alignItems: "center",
  },
  compName: {
    fontSize: JobFontSize.large,
    // color: "#888",
    color: "#222",
    fontWeight: "bold",
  },
  compSubtitle: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    fontSize: JobFontSize.medium,
    color: "#444",
  },
  compDescription: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    fontSize: JobFontSize.medium,
    color: "#888",
  },
  compDescriptionWrap: {
    // overflow: "hidden",
    // whiteSpace: "nowrap",
    // textOverflow: "ellipsis",
    maxWidth: "100%",
    fontSize: JobFontSize.medium,
    color: "#444",
  },
};

const JobPanel = ({ job, handleClick, selected, idx, mobile }) => {
  const [fav, setFav] = useState(job.isFav);
  // on mobile, the user can select multiple of these panels at once
  // each selected panel will be expanded into a JobDetails in place
  const [mobileSelected, setMobileSelected] = useState(false);
  const {
    jobId,
    company,
    jobTitle,
    location,
    locations,
    roleToken,
    experienceLevel,
    jobDescription,
    salaryData,
    bullets,
    skills,
    url,
  } = job;
  const isFetti = jobIsFetti(jobId);
  // if (!isFetti) return null;
  if (mobileSelected && mobile) {
    return (
      <Box sx={{ ...styles.panelBare, ...(selected && styles.selectedPanel) }}>
        <JobDetails
          job={job}
          fav={fav}
          setFav={setFav}
          mobile
          onMobileCollapse={() => setMobileSelected(false)}
          showPortraitAd
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{ ...styles.panel, ...(selected && styles.selectedPanel) }}
      onClick={() => {
        if (mobile && !mobileSelected) {
          setMobileSelected(true);
        }
        handleClick(job);
      }}>
      <Stack
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        spacing="-3px"
        sx={{
          position: "absolute",
          top: JobDisplays.padding,
          right: "10px", // less padding because icon does not fill out its container
          // zIndex: 100,
        }}>
        <FavHeartContainer fav={fav} setFav={setFav} jobId={jobId} />
        <JobDetailsMenu job={job} fav={fav} setFav={setFav} />
      </Stack>
      <Stack direction="column" spacing="0.5rem" sx={{}} alignItems="center">
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          width="100%"
          spacing={1}>
          {/* <Box sx={styles.compLogo}>💸</Box> */}
          <Stack direction="column" sx={{ minWidth: 0, paddingRight: "44px" }}>
            <Box sx={styles.compName}>{jobTitle}</Box>
            <Box sx={styles.compSubtitle}>{company}</Box>
            <Box sx={styles.compSubtitle}>
              {locations ? locations.join(" • ") : location}
            </Box>
          </Stack>
        </Stack>
        <Stack direction="column" sx={{ width: "100%" }} spacing="0.5rem">
          {!isFetti &&
            bullets.map((req, i) => {
              return (
                <Stack direction="row" key={`${idx}-${i}`}>
                  <Box sx={styles.compDescriptionWrap} key={i}>
                    <span style={{ paddingRight: "10px", fontSize: "15px" }}>
                      •
                    </span>
                  </Box>
                  <Box sx={styles.compDescriptionWrap}>
                    {req.charAt(0).toUpperCase() + req.slice(1)}
                  </Box>
                </Stack>
              );
            })}
          {isFetti && (
            <>
              {skills && skills.filter((s) => s != "").length > 0 && (
                <Stack direction="row">
                  <Box sx={styles.compDescriptionWrap}>
                    <span style={{ paddingRight: "10px", fontSize: "15px" }}>
                      •
                    </span>
                  </Box>
                  <Box sx={styles.compDescriptionWrap}>
                    Desired skills: {skills.slice(0, 3).join(", ")}
                  </Box>
                </Stack>
              )}
              {salaryData ? (
                <Stack direction="row">
                  <Box sx={styles.compDescriptionWrap}>
                    <span style={{ paddingRight: "10px", fontSize: "15px" }}>
                      •
                    </span>
                  </Box>
                  <Box sx={styles.compDescriptionWrap}>
                    Estimated salary of {salaryData}
                  </Box>
                </Stack>
              ) : null}
            </>
          )}
        </Stack>

        {/* <Box sx={styles.compDescription}>{jobDescription}</Box> */}
        <Stack
          direction="row"
          width="100%"
          spacing={1}
          sx={{
            overflow: "hidden",
          }}>
          {/* <JobTag tag={location} /> */}
          {isFetti ? (
            <JobTag tag={roleToken} />
          ) : (
            <JobTag tag={getExperienceTag({ roleToken, experienceLevel })} />
          )}
          <JobTag tag={jobTitle} />
        </Stack>
        {/* <Stack direction="row" width="100%" justifyContent="space-between">
          <Box>⭐️ ⭐️ ⭐️ ⭐️ ⭐️</Box>
          <Box>✅ Fetti Verified</Box>
        </Stack> */}
      </Stack>
    </Box>
  );
};

const ScrollJobs = ({
  jobs,
  handleClick,
  selectedJob,
  filterIdx, // idx of the "Best Matches"/"Favorites" toggle
  mobile,
  showDescriptionOverlay,
  searchActiveFilters = null, // data generated by the "JobFiltersBar" component
}) => {
  const useActiveFilters =
    searchActiveFilters !== null &&
    (searchActiveFilters.roles.length > 0 ||
      searchActiveFilters.experienceLevels.length > 0 ||
      searchActiveFilters.locations.length > 0);
  return (
    <Stack direction="column" sx={styles.container} spacing={2}>
      {jobs.map((job, i) => {
        const {
          jobId,
          company,
          jobTitle,
          location,
          locations,
          roleToken,
          experienceLevel,
          jobDescription,
          salaryData,
          bullets,
          skills,
          url,
        } = job;
        return (
          <React.Fragment key={jobId + "-" + i}>
            {(filterIdx === 0 || job.isFav) &&
            (!useActiveFilters ||
              searchActiveFilters.roles.includes(job.roleToken) ||
              searchActiveFilters.experienceLevels.includes(
                job.experienceLevel
              ) ||
              searchActiveFilters.locations.includes(job.location) ||
              (job.locations &&
                job.locations.some((l) =>
                  searchActiveFilters.locations.includes(l)
                ))) ? (
              <JobPanel
                job={job}
                handleClick={handleClick}
                // key={i}
                selected={
                  selectedJob !== null &&
                  selectedJob !== undefined &&
                  selectedJob.url === job.url &&
                  selectedJob.jobId === job.jobId &&
                  !showDescriptionOverlay
                }
                idx={i}
                mobile={mobile}
              />
            ) : null}
          </React.Fragment>
        );
      })}
    </Stack>
  );
};

export default ScrollJobs;
